import styled from 'styled-components'

export const MainContent = styled.div`
  max-height: calc(100vh - 115px);
  overflow-y: auto;
  margin-bottom: 60px;
`